<div class="organism-main-container">
  @if (showBreadcrumb && breadcrumbs.length > 0) {
    <!-- MODO BREADCRUMB -->
    <nav class="breadcrumb-nav" aria-label="Breadcrumb">
      <ol class="breadcrumb-list">
        @for (item of breadcrumbs; track item; let isLast = $last) {
          <li
            class="breadcrumb-item"
            [class.breadcrumb-item--last]="isLast"
            style="cursor: pointer"
          >
            @if (!isLast) {
              <a class="breadcrumb-link" (click)="navigateTo($event, item)" role="button">
                @if (item.icon) {
                  <mat-icon class="breadcrumb-icon">{{ item.icon }}</mat-icon>
                }
                <span class="breadcrumb-text">{{ item.label }}</span>
              </a>
            } @else {
              <span class="breadcrumb-current">
                @if (item.icon) {
                  <mat-icon class="breadcrumb-icon">{{ item.icon }}</mat-icon>
                }
                <span class="breadcrumb-text">{{ item.label }}</span>
              </span>
            }
          </li>
          @if (!isLast) {
            <li class="breadcrumb-separator">
              <mat-icon>chevron_right</mat-icon>
            </li>
          }
        }
      </ol>
    </nav>
  } @else {
    <!-- MODO TRADICIONAL (compatibilidad) -->
    <h1 class="organism-main-title">{{ text }}</h1>
  }
</div>
